import { render } from "./Announcement.vue?vue&type=template&id=69f9dbe5"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__